class FloorsGraphic {
    constructor(config = {}) {
        this.config = {
            defaultColor: '#262626',
            highlightColor: '#FFD700',
            graphicSelector: '#grafica_deptos',
            tabsSelector: '#models-tabs',            // legacy (valor por defecto)
            rootSelector: '[data-js="models"]',      // estructura nueva
            slotSelector: '[data-js="graphic-slot"]',
            ...config
        };

        this.graphic = document.querySelector(this.config.graphicSelector);
        this.tabsContainer = document.querySelector(this.config.tabsSelector);
        this.root = document.querySelector(this.config.rootSelector);

        if (!this.graphic || !this.tabsContainer) return;

        // Si existe el root nuevo, las tabs las maneja initPlantas
        if (this.root) {
            this.initEventMode();
        } else {
            this.initLegacyMode();
        }
    }

    /* ---------- Modo nuevo: escucha el evento de initPlantas ---------- */
    initEventMode() {
        this.root.addEventListener('models:change', ({ detail }) => {
            this.moveToPanel(detail.panel);
            this.highlightFromTab(detail.tab);
        });

        this.highlightFromTab(
            this.tabsContainer.querySelector('[aria-selected="true"]')
        );
    }

    moveToPanel(panel) {
        const slot = panel?.querySelector(this.config.slotSelector);
        if (slot && this.graphic.parentElement !== slot) {
            slot.appendChild(this.graphic);
        }
    }

    /* ---------- Modo legacy: igual que antes ---------- */
    initLegacyMode() {
        this.tabsContainer.querySelectorAll('button').forEach((button) => {
            button.addEventListener('click', (e) => this.handleModelSelect(e));
        });

        this.highlightFirstModel();
    }

    handleModelSelect(event) {
        const button = event.currentTarget;

        this.highlightFromTab(button);
        this.updateActiveButton(button);
    }

    updateActiveButton(button) {
        this.tabsContainer.querySelectorAll('button').forEach((btn) => {
            btn.setAttribute('aria-selected', 'false');
            btn.classList.remove('active');
        });

        button.setAttribute('aria-selected', 'true');
        button.classList.add('active');
    }

    highlightFirstModel() {
        const firstButton = this.tabsContainer.querySelector('button:first-child');
        if (firstButton) {
            this.handleModelSelect({ currentTarget: firstButton });
        }
    }

    /* ---------- Compartido ---------- */
    highlightFromTab(tab) {
        if (!tab) return;

        this.clearHighlights();

        const modelIds = this.parseModelIds(tab);
        if (modelIds.length > 0) {
            this.highlightModelGroups(modelIds);
        }
    }

    parseModelIds(button) {
        try {
            const data = button.dataset.highlightPaths;
            const ids = data ? JSON.parse(data) : [];

            if (!Array.isArray(ids)) {
                console.warn('modelIds no es un array válido:', button);
                return [];
            }
            return ids;
        } catch (error) {
            console.error('Error parseando modelIds:', error, button);
            return [];
        }
    }

    highlightModelGroups(modelIds) {
        modelIds.forEach((modelId) => {
            const group = this.graphic.querySelector(`[data-model-id="${modelId}"]`);

            if (group) {
                group.querySelectorAll('path, [id]').forEach((path) => {
                    if (path.tagName !== 'g') {
                        path.setAttribute('fill', this.config.highlightColor);
                        path.style.filter = 'drop-shadow(0 0 8px rgba(255, 215, 0, 0.8))';
                        path.style.transition = 'all 0.3s ease-in-out';
                    }
                });
            }
        });
    }

    clearHighlights() {
        this.graphic.querySelectorAll('[style*="filter"]').forEach((el) => {
            el.setAttribute('fill', this.config.defaultColor);
            el.style.filter = 'none';
        });
    }
}

export default FloorsGraphic;
